export var TestCommand;
(function (TestCommand) {
    TestCommand["Click"] = "click";
    TestCommand["Text"] = "text";
    TestCommand["Wait"] = "wait";
    TestCommand["WaitUntilRegex"] = "waitUntilRegex";
    TestCommand["WaitUntilNotRegex"] = "waitUntilNotRegex";
    TestCommand["Upload"] = "upload";
    TestCommand["AddTests"] = "addTests";
    TestCommand["CheckBox"] = "checkBox";
    TestCommand["TourNote"] = "tourNote";
})(TestCommand || (TestCommand = {}));
